export enum marketSegmentType {
    Individual = 1,
    Group = 2,
    LargeGroup = 3
  }
  